import Vue from 'vue';
import App from './app/App.vue';
import VueI18n from 'vue-i18n';

const supportedLanguages = ['de', 'fr'];

function i18nMessages(supportedLanguages) {
  var returnObj = {};
  supportedLanguages.forEach(function(el) {
    returnObj[el] = require(`./i18n/${el}.json`);
  });

  return returnObj;
}

function preferredBrowserLanguage(appLanguages) {
  if (location.hash && location.hash.match(/#\/(\S{2})$/) && appLanguages.includes(RegExp.$1))
    return RegExp.$1;

  for (var lang of navigator.languages) {
    for (var appLang of appLanguages) {
      if (lang.indexOf(appLang) >= 0)
        return appLang;
    }
  }
}

Vue.config.productionTip = false;
Vue.use(VueI18n);

new Vue({
  render: h => h(App),
  i18n: new VueI18n({
    messages: i18nMessages(supportedLanguages),
    locale: preferredBrowserLanguage(supportedLanguages) || 'de',
  })
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js